module.exports = __webpack_public_path__ + "img/uid-token-btn.38c6c1bc.png";